import { CountryModel } from "src/app/models/common/countrymodel";
import { StateNestedModel } from "../../../models/common/statemodel";
import { PhoneModel } from "src/app/models/common/phone-model";

interface IRegisterCompanyModel {
    id?: string;
    name: string;
    country?: string | CountryModel;
    address?: string;
    state?: string | StateNestedModel;
    group_name?: string;
}

export interface IRegisterModel {
    id?: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: PhoneModel;
    // Commented for Lead Verification 
    // company: IRegisterCompanyModel; (remove country, state and address when uncommenting this line)
    company_name: string;
    country?: string | CountryModel;
    state?: string | StateNestedModel;
    address?: string;
    token_data?: any;
    token?: string;
    lead_request?: string[];
    throttle_period?: number;
}

export interface IRegisterError {
    id: string[];
    first_name: string[];
    last_name: string[];
    email: string[];
    phone: string[];
    company_name: string[];
    country: string[];
    state: string[];
    address: string[];
    token_data?: string[];
    token?: string[];
    redirect_to_login?: string[];
}

export class RegisterModel implements IRegisterModel {
    id?: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: PhoneModel;
    // company: IRegisterCompanyModel; (remove country, state and address when uncommenting this line)
    company_name: string;
    country?: CountryModel;
    state?: StateNestedModel;
    address?: string;
    lead_request?: string[];

    errors: IRegisterError;

    constructor() {
        this.id = null;
        this.first_name = null;
        this.last_name = null;
        this.email = null;
        this.phone = null;
        this.company_name = null;
        this.country = null;
        this.state = null;
        this.address = null;
        this.lead_request = [];

        this.resetErrors();
    }

    static fromJSON(data: any): RegisterModel {
        return Object.assign(new RegisterModel(), data);
    }

    resetErrors() {
        this.errors = {
            id: [],
            first_name: [],
            last_name: [],
            email: [],
            phone: [],
            company_name: [],
            country: [],
            state: [],
            address: [],
            token_data: [],
            token: [],
            redirect_to_login: [],
        }

    }

    validate() {
        this.resetErrors();

        const nameRegex = /^[A-Za-z]{3,}$/;

        if (!this.first_name) {
            this.errors.first_name = ['First name is required.'];
        } else if (nameRegex.test(this.first_name) == false) {
            this.errors.first_name = ['First Name should be minimum of 3 characters and should not contain any numbers and special characters'];
        }


        if (!this.last_name) {
            this.errors.last_name = ['Last name is required.'];
        } else if (nameRegex.test(this.last_name) == false) {
            this.errors.last_name = ['Last Name should be minimum of 3 characters and should not contain any numbers and special characters'];
        }

        if (!this.email) {
            this.errors.email = ['Email is required.'];
        }

        if (!this.company_name) {
            this.errors.company_name = ['Company Name is required.'];
        } else if (this.company_name.length < 3) {
            this.errors.company_name = ['Company Name should be minimum of 3 characters'];
        }

        if (!this.country) {
            this.errors.country = ['Country is required.'];
        }
        if (!this.state) {
            this.errors.state = ['State is required.'];
        }
        if (!this.phone) {
            this.errors.phone = ['Mobile number is required.'];
        }

        return Object.keys(this.errors).reduce((acc, key) => acc && this.errors[key].length === 0, true);

    }

    getRegisterPayload() {
        return {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            phone: typeof this.phone == 'object' && this.phone != null ? this.phone.as_e164 : this.phone,
            company_name: this.company_name,
            country: typeof this.country == 'object' && this.country != null ? this.country.id : this.country,
            state: typeof this.state == 'object' && this.state != null ? this.state.id : this.state,
            address: this.address,
            lead_request: this.lead_request,
        }
    }
}

export interface IOtpModel {
    otp: string;
    password: string;
    password_confirm: string;
    token?: string;
}

export interface OtpError {
    otp: string[];
    password: string[];
    password_confirm: string[];
}

export class OtpModel implements IOtpModel {
    otp: string;
    password: string;
    password_confirm: string;
    token?: string;

    errors: OtpError

    constructor() {
        this.otp = null;
        this.password = null;
        this.password_confirm = null;

        this.resetOtpErrors();
    }

    resetOtpErrors() {
        this.errors = {
            otp: [],
            password: [],
            password_confirm: [],
        }
    }

    validatePassword() {
        this.resetOtpErrors();
        if (!this.password) {
            this.errors.password = ['Password is required.'];
        }
        if (!this.password_confirm) {
            this.errors.password_confirm = ['Re-confirm the password.'];
        }
        if (this.password !== this.password_confirm) {
            this.errors.password_confirm = ['Re-confirmed password does not match.'];
        }

        return Object.keys(this.errors).reduce((acc, key) => acc && this.errors[key].length === 0, true);
    }

    getOtpPayload() {
        return {
            otp: this.otp,
            token: this.token,
        }
    }

    getPasswordPayload() {
        return {
            password: this.password,
            token: this.token,
        }
    }
}
